import { useClassName } from '@/styles/CoverBox';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type CoverBoxIconProps = ComponentProps<'div'>;

export const CoverBoxIconComponent: Component<CoverBoxIconProps> = ({ children, ...props }) => {
  const className = useClassName('icon', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
